import React, { useState, useMemo } from 'react';
import { useOrganizations } from '../hooks/useOrganizations';
import LoadingScreen from '../components/common/LoadingScreen';
import ProductList from '../components/products/ProductList';
import { BuildingOffice2Icon, CubeIcon } from '@heroicons/react/24/outline';
import { useLanguage } from 'contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';

const Products = () => {
  const { organizations, loading } = useOrganizations();
  const [selectedOrg, setSelectedOrg] = useState<string>('all');
  const { t } = useLanguage();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t('products.title')}
        subtitle={t('products.subtitle') || 'Termékek kezelése és áttekintése'}
        icon={CubeIcon}
      >
        <div className="flex flex-wrap sm:flex-nowrap items-center gap-2 overflow-x-auto pb-2">
          <button
            onClick={() => setSelectedOrg('all')}
            className={`flex-none inline-flex items-center px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-xs sm:text-sm whitespace-nowrap bg-white/20 dark:bg-gray-700/20 backdrop-blur-sm text-white hover:bg-white/30 dark:hover:bg-gray-700/30 transition-colors
              ${selectedOrg === 'all'
                ? 'border-white/50 dark:border-gray-300/50 bg-white/30 dark:bg-gray-700/30'
                : 'border-white/20 dark:border-gray-600 hover:border-white/40 dark:hover:border-gray-500'
              }`}
          >
            <BuildingOffice2Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
            {t('products.organizations')}
          </button>
          {organizations.map(org => (
            <button
              key={org.id}
              onClick={() => setSelectedOrg(org.id)}
              className={`flex-none inline-flex items-center px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg border text-xs sm:text-sm whitespace-nowrap bg-white/20 dark:bg-gray-700/20 backdrop-blur-sm text-white hover:bg-white/30 dark:hover:bg-gray-700/30 transition-colors
                ${selectedOrg === org.id
                  ? 'border-white/50 dark:border-gray-300/50 bg-white/30 dark:bg-gray-700/30'
                  : 'border-white/20 dark:border-gray-600 hover:border-white/40 dark:hover:border-gray-500'
                }`}
            >
              <BuildingOffice2Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
              {org.name}
            </button>
          ))}
        </div>
      </CommonPageHeader>

      <ProductList selectedOrg={selectedOrg} />
    </div>
  );
};

export default Products; 